import http from "../http-common";

class CalculoService {

    ingresar(data) {
        return http.post("/calculo",data);
    }

    getByIdCausal(id_causal) {
        return http.get(`/calculo/causal/${id_causal}`);
    }

    update(id_calculo, data) {
        return http.put(`/Calculo/${id_calculo}`,data);
    }
}

export default new CalculoService();